import { Box, Icon, Input, InputElement } from '@chakra-ui/react';
import React, {
  FunctionComponent as FC,
  useEffect,
  useRef,
  useState,
} from 'react';
import { MdSearch } from 'react-icons/md';
import { MCloseButton } from '../../../../components/Monetize';
import { useDebounce } from '../../../../hooks/useDebounce';

interface SettingSearchInputProps {
  value: string;
  onChange: (val: string) => void;
  count?: number;
}

export const SettingSearchInput: FC<SettingSearchInputProps> = React.forwardRef<
  any,
  SettingSearchInputProps
>(({ value, onChange, count = 0 }: SettingSearchInputProps, ref) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const [internalValue, setInternalValue] = useState(value);
  const debouncedValue = useDebounce(internalValue);

  useEffect(() => {
    setInternalValue(value);
  }, [value]);

  useEffect(() => {
    onChange(debouncedValue);
  }, [debouncedValue]);

  useEffect(() => {
    // Use setTimeout to ensure DOM is fully rendered before focusing
    const timer = setTimeout(() => {
      if (inputRef.current) {
        inputRef.current.focus();
      }
    }, 0);

    return () => clearTimeout(timer);
  }, []);

  const handleOnKeyDown = (ev: React.KeyboardEvent) => {
    if (ev.key === 'Enter') {
      onChange(internalValue);
    }
  };

  const onSetEmpty = () => {
    onChange('');
  };
  const mainInputP = 4;
  let inputRightElementW = 70;
  if (internalValue) {
    inputRightElementW = 88;
  }

  return (
    <Box position="relative" maxW="310px">
      <InputElement
        placement="start"
        pointerEvents="none"
        w="8"
        textAlign="center"
        top="0"
      >
        <Icon w="4" h="4" color="tPurple.base" asChild>
          <MdSearch />
        </Icon>
      </InputElement>
      <Input
        data-testid="search-input"
        type="text"
        ref={inputRef}
        placeholder="Search..."
        value={internalValue}
        onChange={(e) => setInternalValue(e.target.value)}
        onBlur={() => onChange(internalValue)}
        onKeyDown={handleOnKeyDown}
        _placeholder={{
          color: 'tGray.darkGrayPurple',
        }}
        pl="8"
        pr={inputRightElementW + mainInputP}
      />

      {internalValue && (
        <InputElement
          placement="end"
          w={inputRightElementW}
          justifyContent="flex-end"
          px="0"
          top="0"
        >
          <MCloseButton onClick={() => onSetEmpty()} mr="2" />
        </InputElement>
      )}
    </Box>
  );
});
